module.exports = __webpack_public_path__ + "static/img/4104_phase_function_Paper_PointsHejduk_Prediction.912ccf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4104_phase_function_Paper_PointsHejduk_Prediction.png
// module id = hywd
// module chunks = 0